//export const ServiceUrl = "https://localhost:5001/api/";
//export const ServiceUrl = "https://st-137261.dynamicstocloud.com:8301/api/"; //saas
//export const ServiceUrl = "https://sf-114487-1.dynamicstocloud.com:8012/api/"; //saas astena server
export const ServiceUrl = "https://serviceappapi.omerdeloof.be:30445/api/"; //saas nieuw
//export const ServiceUrl = "https://localhost:8001/api/";

//https://serviceapp.omerdeloof.be:30444 
//https://serviceappapi.omerdeloof.be:30445 

